import { useMemo, useState } from "react";
import { AppointmentReportAiReportViewDialogProps } from ".";
import { AppointmentReport } from "../AppointmentReportGrid/types";

const useAppointmentReportAiReportViewDialog = (params: {
  reports: AppointmentReport[];
  customerName: string;
  locationCity: string;
  studyNames: string[];
  appointmentDate: string;
}): {
  props: AppointmentReportAiReportViewDialogProps | null;
  isOpened: boolean;
  onOpenClick: (id: string) => void;
} => {
  const { reports, customerName, locationCity, studyNames, appointmentDate } =
    params;
  const [reportId, setReportId] = useState<string | null>(null);

  const onOpenClick = (id: string) => setReportId(id);
  const handleClose = () => setReportId(null);

  const report = useMemo(() => {
    if (!reportId) return null;
    const found = reports.find(({ id }) => id === reportId);
    return found && found.type === "ai" ? found : null;
  }, [reportId, reports]);

  const isOpened = !!reportId;

  return {
    isOpened,
    onOpenClick,
    props: report
      ? {
          isOpened,
          sections: report.sections,
          customerName,
          locationCity,
          studyNames,
          appointmentDate,
          handleClose,
        }
      : null,
  };
};

export default useAppointmentReportAiReportViewDialog;
